import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WfDialogService } from 'wflow-ui';
import { ProfileDetailsDialogComponent } from '../components/profile-details/profile-details-dialog.component';
import { RouterState } from 'wflow-main-app/src/app/store/router/router.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  public isOrgContext$: Observable<boolean>;
  private readonly translateSvc = inject(TranslateService);
  private readonly dialogSvc = inject(WfDialogService);

  constructor(
    private store: Store<{
      router: RouterState;
    }>,
  ) {
    this.isOrgContext$ = this.store
      .select(({ router }) => router?.state?.segments)
      .pipe(map((segments) => segments.includes('org')));
  }

  public openProfileDetailsDialog() {
    return this.dialogSvc.open(ProfileDetailsDialogComponent, {
      title: this.translateSvc.instant('PROFILE_DETAILS_DIALOG.Title'),
    });
  }
}
